(function () {
  if (window.__nnFocusInit) return;
  window.__nnFocusInit = true;

  var FOCUS_ROTATE_MS = 3800;

  function revealShot(items, pick) {
    items.forEach(function (el) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.classList.remove('is-focus-active');
    });

    pick.hidden = false;
    pick.removeAttribute('aria-hidden');
    pick.classList.add('is-focus-active');
    pick.style.animation = 'none';
    void pick.offsetWidth;
    pick.style.animation = '';

    var img = pick.querySelector('img');
    if (img) {
      img.setAttribute('fetchpriority', 'high');
      img.loading = 'eager';
      img.style.animation = 'none';
      void img.offsetWidth;
      img.style.animation = '';
    }

    try {
      window.sessionStorage.setItem(
        'nn-focus-handle',
        pick.getAttribute('data-nn-focus-item') || ''
      );
    } catch (e) {}
  }

  function pickDifferent(items, current) {
    var pool = items;
    if (current && items.length > 1) {
      var filtered = items.filter(function (el) {
        return el !== current;
      });
      if (filtered.length) pool = filtered;
    }
    return pool[Math.floor(Math.random() * pool.length)];
  }

  function startFocusRotation(root) {
    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-nn-focus-item]')
    );
    if (!items.length) return;

    var storageKey = 'nn-focus-handle';
    var last = null;
    try {
      last = window.sessionStorage.getItem(storageKey);
    } catch (e) {}

    var initialPool = items;
    if (last && items.length > 1) {
      var filtered = items.filter(function (el) {
        return el.getAttribute('data-nn-focus-item') !== last;
      });
      if (filtered.length) initialPool = filtered;
    }

    var current =
      initialPool[Math.floor(Math.random() * initialPool.length)] || items[0];
    revealShot(items, current);

    if (items.length < 2) {
      root.classList.add('is-focus-static');
      return;
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) {
      root.classList.add('is-focus-static');
      return;
    }

    var timer = null;
    var paused = false;
    var remainingMs = FOCUS_ROTATE_MS;
    var endsAt = 0;

    function setTimerPaused(isPaused) {
      root.classList.toggle('is-timer-paused', isPaused);
    }

    /** Fresh cycle — reset chip fill from empty */
    function startTimerVisual() {
      root.style.setProperty('--nn-focus-rotate', FOCUS_ROTATE_MS + 'ms');
      root.classList.remove('is-timer-running', 'is-timer-paused');
      void root.offsetWidth;
      root.classList.add('is-timer-running');
      setTimerPaused(false);
    }

    function armTimeout(delay) {
      clearTimeout(timer);
      remainingMs = delay;
      endsAt = Date.now() + delay;
      timer = window.setTimeout(function () {
        if (paused || reduceMotion.matches) return;
        current = pickDifferent(items, current);
        revealShot(items, current);
        beginCycle();
      }, delay);
    }

    function beginCycle() {
      if (paused || reduceMotion.matches) return;
      startTimerVisual();
      armTimeout(FOCUS_ROTATE_MS);
    }

    function resumeCycle() {
      if (paused || reduceMotion.matches) return;
      var delay = Math.max(50, remainingMs);
      setTimerPaused(false);
      armTimeout(delay);
    }

    root.addEventListener('mouseenter', function () {
      if (paused) return;
      paused = true;
      clearTimeout(timer);
      remainingMs = Math.max(50, endsAt - Date.now());
      setTimerPaused(true);
    });

    root.addEventListener('mouseleave', function () {
      if (!paused) return;
      paused = false;
      resumeCycle();
    });

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', function () {
        if (reduceMotion.matches) {
          clearTimeout(timer);
          paused = false;
          root.classList.remove('is-timer-running', 'is-timer-paused');
          root.classList.add('is-focus-static');
        } else {
          root.classList.remove('is-focus-static');
          beginCycle();
        }
      });
    }

    beginCycle();
  }

  function pickSeriesMedia(root) {
    var images = Array.prototype.slice.call(root.querySelectorAll('img'));
    if (!images.length) return;

    var series = root.getAttribute('data-nn-series-media') || 'series';
    var storageKey = 'nn-series-img:' + series;
    var last = null;
    try {
      last = window.sessionStorage.getItem(storageKey);
    } catch (e) {}

    var choices = images;
    if (last && images.length > 1) {
      var filtered = images.filter(function (img) {
        return img.getAttribute('data-nn-series-img') !== last;
      });
      if (filtered.length) choices = filtered;
    }

    var pick = choices[Math.floor(Math.random() * choices.length)];
    if (!pick) return;

    images.forEach(function (img) {
      img.hidden = true;
      img.setAttribute('aria-hidden', 'true');
    });

    pick.hidden = false;
    pick.removeAttribute('aria-hidden');
    pick.loading = 'eager';

    try {
      window.sessionStorage.setItem(
        storageKey,
        pick.getAttribute('data-nn-series-img') || ''
      );
    } catch (e) {}
  }

  function startAtmosphere(root) {
    var frames = Array.prototype.slice.call(
      root.querySelectorAll('[data-nn-atmosphere-img]')
    );
    if (frames.length < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    var index = frames.findIndex(function (img) {
      return img.classList.contains('is-active');
    });
    if (index < 0) index = 0;

    window.setInterval(function () {
      if (reduceMotion.matches) return;
      frames[index].classList.remove('is-active');
      index = (index + 1) % frames.length;
      frames[index].classList.add('is-active');
    }, 9000);
  }

  function applyHeroPresentation() {
    if (document.getElementById('nn-hero-present-v3')) return;
    var style = document.createElement('style');
    style.id = 'nn-hero-present-v3';
    style.textContent =
      '.nn-split{isolation:isolate}' +
      '.nn-split__atmosphere{position:absolute!important;inset:0!important;z-index:0!important;overflow:hidden!important;pointer-events:none!important}' +
      '.nn-split__atmosphere::after{content:\"\"!important;position:absolute!important;inset:0!important;z-index:1!important;background:linear-gradient(180deg,rgba(31,31,31,.35) 0%,rgba(31,31,31,.55) 42%,rgba(31,31,31,.88) 100%),linear-gradient(115deg,rgba(31,31,31,.2) 0%,rgba(118,192,67,.1) 48%,rgba(31,31,31,.45) 100%)!important}' +
      '.nn-split__atmosphere-img{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;transform:scale(1.14)!important;filter:blur(4px)!important}' +
      '.nn-split__atmosphere-img.is-active{opacity:1!important}' +
      '.nn-split__type{background:transparent!important;position:relative!important;z-index:2!important}' +
      '.nn-split__visual{display:none!important}' +
      '.nn-split__mark{display:block!important;z-index:1!important}' +
      '@media (min-width:900px){.nn-split{grid-template-columns:1fr!important;min-height:92vh!important;min-height:92svh!important}}';
    document.head.appendChild(style);
  }

  function init() {
    applyHeroPresentation();
    document.querySelectorAll('[data-nn-focus-root]').forEach(startFocusRotation);
    document.querySelectorAll('[data-nn-atmosphere]').forEach(startAtmosphere);
    document.querySelectorAll('[data-nn-series-media]').forEach(pickSeriesMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* present-v3 1784561603 */

/* hide-focus 1784561714 */

/* blur-4 1784561804 */

/* keep-glitch-99 1784561937 */

/* brand-gradient 1784562163 */
